<template>
    <div :id="id" class="row">
      <LmTextInput
        ref="inputFocus"
        :id="id + 'label'"
        class="col-12 col-md-4"
        v-model="component.componentProps.label"
        @input="onLabelChange($event)"
        :label="$t('title')"
        :placeholder="$t('title')"
        :help="$t('comp_title_help')"
      />
      <LmTextInput
        v-if="validateSuperUser"
        class="col-12 col-md-4"
        :id="id + 'nombre'"
        v-model="component.formObjectToSendToServerProperty"
        @input="$emit('input', component); $emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
        :label="$t('name')"
        :placeholder="$t('name')"
        :help="$t('comp_name_help')"
      />
      <LmTextInput
        class="col-12 col-md-4"
        :id="id + 'placeholder'"
        v-model="component.componentProps.placeholder"
        @input="$emit('input', component)"
        :label="$t('placeholder')"
        :placeholder="$t('placeholder')"
        :help="$t('comp_placeholder_help')"
      />
      <LmTextInput
        class="col-12 col-md-8"
        :id="id + 'help'"
        v-model="component.componentProps.help"
        @input="$emit('input', component)"
        :label="$t('helper_text_setter')"
        :placeholder="$t('helper_text_setter')"
        :help="$t('helper_text_setter_help')"
      />
      <LmSelect
        :id="id + 'css'"
        class="col-12 col-md-4"
        v-model="component.class"
        :options="{
          content: [
            {value: 'col-12 col-md-3',text: '25%'},
            {value: 'col-12 col-md-6', text: '50%'},
            {value: 'col-12 col-md-9', text: '75%'},
            {value: 'col-12 col-md-12', text: '100%'}
          ]
        }"
        :label="$t('desktop_view_width')"
        :help="$t('help_width_form_element')"
        @input="$emit('input', component)"
      />
      <hr class="w-100 mx-2">
      <div class="col-12">
        <h5>{{ $t('validations') }}</h5>
        <div class="row align-items-center">
          <LmCheckbox
            class="col-12 col-md-4"
            :labelSingle="$t('required')"
            v-model="validations.required"
            @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
          />
          <LmNumberInput
            :id="`min-length-${id}`"
            class="col-12 col-md-4"
            v-model="validations.minLength"
            @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
            :label="$t('min_length')"
            />
          <LmNumberInput
            :id="`max-length-${id}`"
            class="col-12 col-md-4"
            v-model="validations.maxLength"
            @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
            :label="$t('max_length')"
            />
          <LmSelect
            v-if="component.componentName !== 'LmEditor'"
            :id="id + 'same-as'"
            class="col-12 col-md-4"
            v-model="validations.sameAs"
            :options="optionsSameAsValidation"
            :label="$t('value_has_to_be_equal_to')"
            @input="onInputValidationSameAs(optionsSameAsValidation.content.find(e => e.value === validations.sameAs))"
          />
        </div>
      </div>
      <hr class="w-100 mx-2">
      <LmConditionalBuilderUi
        v-if="isVisibleCondition"
        class="col-12"
        :visibilityDependOnConditions="visibilityDependOnConditions"
        :self="component.formObjectToSendToServerProperty"
      />
      <LmConditionalByEditModeBuilderUi
        :component="component"
        @input="$emit('input', component)"
        />
    </div>
</template>

<script>
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'
export default {
  mixins: [lmFormElementsBuilderUiMixin],
  data () {
    return {
      validations: {
        required: false,
        minLength: '',
        maxLength: '',
        sameAs: ''
      }
    }
  },
  watch: {
    componentData () {
      this.component = this.componentData
    }
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    }
  }
}
</script>
